function modifyCartPricesAndTotal() {
    let rebuyItems = Rebuy.SmartCart.items(0); // Get Rebuy cart items
    let cartList = document.querySelector("ul.rebuy-cart__flyout-items"); 
    let total = 0;

    if (!cartList) return;

    let cartItems = Array.from(cartList.querySelectorAll(".rebuy-cart__flyout-item")); // Get all cart items

    cartItems.forEach(function (li) {
        let priceElement = li.querySelector(".rebuy-cart__flyout-item-price");
        if (!priceElement) return;

        let productTitle = li.querySelector('.rebuy-cart__flyout-item-product-title')?.textContent.trim();
        let variantTitle = li.querySelector('.rebuy-cart__flyout-item-variant-title')?.textContent.trim(); // Get variant name

        // Match both product title and variant title
        let rebuyItem = rebuyItems.find(item => 
            item.product_title === productTitle && 
            item.variant_title === variantTitle
        );

        let finalLinePrice = rebuyItem.final_line_price || 0;
        
        // **Only modify items that have a selling plan**
        if (rebuyItem && rebuyItem.selling_plan_allocation) {
            
            let depositAmountNumeric = (finalLinePrice * 0.05) || 0; // Assuming 5% deposit for selling plan items

            // Add class and update content
            priceElement.classList.add("rebuy-money", "sale");
            priceElement.innerHTML = 
                `${Rebuy.SmartCart.formatMoney(depositAmountNumeric)} ( ${Rebuy.SmartCart.formatMoney(finalLinePrice)} if kept)`;

          total += depositAmountNumeric;
        
        } else {

          total += finalLinePrice;
        }

        
    });

    

    let cartTotalElement = document.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
      
    
    if (cartTotalElement) {
        let priceSpan = cartTotalElement.querySelector("span:last-child"); // Select the dollar amount span
        
        if (priceSpan) {
            priceSpan.textContent = Rebuy.SmartCart.formatMoney(total); // ✅ Use the updated total
        }
    }

    console.log("✅ Updated Selling Plan Items in Rebuy Cart!");
}

// **Wait for Rebuy to Finish Loading the Cart Before Running the Function**
function waitForRebuyUpdate(callback, retries = 15) {
    setTimeout(() => {
        let cartList = document.querySelector(".rebuy-cart__flyout-items");
        let rebuyItems = Rebuy.SmartCart.items(0);

        if (cartList && cartList.children.length > 0 && rebuyItems.length > 0) {
            callback();
        } else if (retries > 0) {
            waitForRebuyUpdate(callback, retries - 1);
        }
    }, 500); // Wait 500ms between checks
}

// **Attach to Rebuy Cart Events**
function setupRebuyListeners() {
    document.addEventListener("rebuy:smartcart.ready", () => waitForRebuyUpdate(modifyCartPricesAndTotal));
    document.addEventListener("rebuy:smartcart.show", () => waitForRebuyUpdate(modifyCartPricesAndTotal));
    document.addEventListener("rebuy:smartcart.line-item-increase", () => waitForRebuyUpdate(modifyCartPricesAndTotal));
    document.addEventListener("rebuy:smartcart.line-item-decrease", () => waitForRebuyUpdate(modifyCartPricesAndTotal));
    document.addEventListener("rebuy:smartcart.line-item-remove", () => waitForRebuyUpdate(modifyCartPricesAndTotal));
    document.addEventListener("rebuy:smartcart.update", () => waitForRebuyUpdate(modifyCartPricesAndTotal)); // ✅ Ensure updates happen even after Rebuy cart changes
}

// **Observe Cart for Changes**
function observeCartChanges() {
    let cartContainer = document.querySelector("#rebuy-cart");
    if (!cartContainer) return;

    let observer = new MutationObserver(() => {
        waitForRebuyUpdate(modifyCartPricesAndTotal);
    });

    observer.observe(cartContainer, { childList: true, subtree: true });
}

// **Ensure Changes Persist on Page Refresh**
document.addEventListener("DOMContentLoaded", () => {
    waitForRebuyUpdate(modifyCartPricesAndTotal);
    setupRebuyListeners();
    observeCartChanges();
});
